





















import {Vue, Component, Prop} from "vue-property-decorator";
import FilterSelect from "@common/table/components/filter/FilterSelect.vue";
import {FilterSetting} from "@common/table/interfaces/FilterSetting";
import ControlWrapper from "@share/common/ControlWrapper.vue";
import {TranslateResult} from "vue-i18n";
import {CssStyle} from "@common/table/data"
import { Debounce } from "vue-debounce-decorator";

@Component({
    components: {FilterSelect, ControlWrapper}
})

export default class QuickFilters extends Vue {
    @Prop({ default: () => [] }) filters: FilterSetting[];
    @Prop({ default: 20 }) offsetForHide: number;

    prevWidth = 0;

    mounted() {
        window.addEventListener('resize', this.windowResizeHandler);
        this.hideItemsIfNeed();
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.windowResizeHandler);
    }

    onDecreaseWindowSize(selfChildren: Element[], parentContainer: Element) {
        if(!this.getEnough(parentContainer)) {

            selfChildren.reduce((prev, current, index) => {
                const hidden = current.attributes.getNamedItem('hidden')?.value === "true";
                if(hidden) {
                    //hide prev
                    prev.setAttribute("hidden", "true")
                }

                else if (index === selfChildren.length - 1) {
                    //hide last
                    current.setAttribute("hidden", "true")
                }

                return current;
            })
        }
    }

    onIncreaseWindowSize() {
        const childList = Array.from(this.$el.children);

        for (const child of childList) {
            const hidden = child.attributes.getNamedItem('hidden')?.value === "true";

            if(hidden) {
                child.removeAttribute("hidden");

                if(!this.getEnough(this.getParentContainer())) {
                    //hide again if space not enough
                    child.setAttribute("hidden", "true");
                }

                break;
            }
        }
    }

    hideItemsIfNeed() {
        const parentContainer = this.getParentContainer();
        do {
            this.onDecreaseWindowSize(Array.from(this.$el.children), parentContainer)
        } while (!this.getEnough(parentContainer));
    }

    @Debounce(13)
    windowResizeHandler() {
        const parentContainer = this.getParentContainer();
        const increase = this.prevWidth < parentContainer.clientWidth;

        if(increase) {
            this.onIncreaseWindowSize();
        }
        else {
            this.onDecreaseWindowSize(Array.from(this.$el.children), parentContainer);
        }

        this.prevWidth = parentContainer.clientWidth;
    }

    getParentContainer() {
        return this.$el.parentElement as Element;
    }

    getEnough(parentContainer: Element) {
        const childrenSumWidth = Array.from(parentContainer.children).map((item) => item.clientWidth).reduce((prev, acc) => prev + acc, 0)
        return (childrenSumWidth + this.offsetForHide) <= parentContainer.clientWidth
    }

    getClass(filter: FilterSetting) {
        let className = '';
        if (filter?.quickFilterSettings?.class) {
            className += ` ${filter.quickFilterSettings.class}`
        }
        return className;
    }

    getStyle(filter: FilterSetting) {
        let style: CssStyle = {};
        if (filter?.quickFilterSettings?.width) {
            style.width = filter.quickFilterSettings.width;
        }
        return style;
    }

    getPlaceholder(filter: FilterSetting) {
        let placeholder: string | TranslateResult = '';

        if (filter?.title) {
            placeholder = filter.title;
        }

        if (filter?.quickFilterSettings?.title) {
            placeholder = filter.quickFilterSettings.title;
        }
        return placeholder;
    }

    getSelectValue(filter: FilterSetting) {
        this.$emit('setSelectFilter', filter);
        this.$emit('apply');
    }

    get sortFilterItems() {
        return this.filters.filter((filterItem: FilterSetting) => {
            return filterItem.isPresentInQuickFilter;
        }).sort((a: { [key: string]: any }, b: { [key: string]: any }) => {
            if (
                a?.quickFilterSettings?.sortingWeight &&
                b?.quickFilterSettings?.sortingWeight
            ) {
                let aSortingWeight: number = a.quickFilterSettings.sortingWeight;
                let bSortingWeight: number = b.quickFilterSettings.sortingWeight;

                if (aSortingWeight > bSortingWeight) {
                    return 1;
                }

                if (aSortingWeight < bSortingWeight) {
                    return -1;
                }
            }

            return 0;
        });
    }

    getKey(filter: FilterSetting) {
        if (filter.key) {
            return filter.key;
        }
        return filter.name;
    }
}
